module.exports = __webpack_public_path__ + "static/KAL6-0eb4ce92ab86caad9b79a8d7a27c8832.png";